import { render } from "./DashboardUsers.vue?vue&type=template&id=c1d00a1a&scoped=true"
import script from "./DashboardUsers.vue?vue&type=script&lang=js"
export * from "./DashboardUsers.vue?vue&type=script&lang=js"

import "./DashboardUsers.vue?vue&type=style&index=0&id=c1d00a1a&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d00a1a"]])

export default __exports__